export const alarmsConstants = {
    GET_REQUEST: 'ALARMS_GET_REQUEST',
    GET_SUCCESS: 'ALARMS_GET_SUCCESS',
    GET_FAILURE: 'ALARMS_GET_FAILURE',
}